<!-- <section class="content-header">
    <h1>
        {{title}}
    </h1>
</section> -->
<section class="content">
    <section>
        <div class="row">
            <div class="box  box-primary">
                <PageHeader class="pageHeaderButtonPosition" [title]="title" 
                        [(searchText)]="searchText"
                        [isSearchOpen]="ShowSearch"
                        (searchShowChange)="onSearchShowChange($event)"
                        [showAddNew]=false [addurl]='AddUrl' #pageheader
                        [showMainListing]="false">
                    </PageHeader>                
                    <div
                    id="divSearch row"
                    *ngIf="ShowSearch"
                >

                    <div class="col-md-12 box ibox box-primary boxSearch">
                        <div class="box-header">
                            <h3 class="box-title">Search Records</h3>
                        </div>
                       
                                      
                        
                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Category:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" [(ngModel)]="Category" (change)="fillModelList()">
                                                    <option value="{{item.value}}" *ngFor="let item of CategoryList" >
                                                        {{item.text}}
                                                    </option>
                                                </select>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Model:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" [(ngModel)]="Model">
                                                    <option value="">Select</option>
                                                    <option value="{{item.value}}" *ngFor="let item of ModelList">
                                                        {{item.text}}
                                                    </option>
                                                </select>

                                            </div>
                                        </div>
                                    </div>
                                  
                                </div>
                            </div>
                            <!-- <div class="box-body row">
                                <div class="col-sm-12">
                                    <div class="col text-center">
                                        <button
                                            class="btn btn-primary"
                                            id="btnSearchDetail"
                                            (click)="executeFieldMasterSearch()"
                                        >
                                            <span>
                                                <i class="fa fa-search"></i>
                                            </span>
                                            <b>Search</b>
                                        </button>
                                    </div>
                                </div>
    
                            </div> -->
                            <searchbutton (searchClick)="executeFieldMasterSearch()" (cancelClick)="hideSearch()"></searchbutton>

                        </div>  
                       
                    </div>
                </div>

                <div class="clearfix"></div>
                <div class="box-body" id="dvboxbody">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-9 pull-right zIndex1000">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="{{pageSize}}" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                    <div class="col text-left noofrecords">
                                        <span><b>  {{page.totalElements}}
                                                    {{page.totalElements > 1 ? 'Records' : 'Record'}} Found. </b>
                                        </span>
                                        <span *ngIf="blnDirtySearch">
                                                <a style="cursor:pointer"
                                                    (click)="executeFieldMasterSearchClear()">
                                                    (<span><i class="fa fa-trash-o"></i></span>
                                                        <b>Clear Search</b>
                                                </a>)
                                        </span>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div class="table-responsive-custom">
                        <table id="OptionList" class="table table-bordered table-striped dataTable no-footer"
                            role="grid">
                            <thead>
                                <tr>
                                    <th *ngFor="let tableHeader of tableHeaders"
                                        [ngClass]="setSortIndicator(tableHeader.Label)"
                                        [style.width.%]="tableHeader.Width" (click)="changeSorting(tableHeader.Label)">
                                        {{tableHeader.Label}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let fieldMasterDetails of rows;let index=index;"
                                    (click)="_onRowClick(fieldMasterDetails.modelId)" class="pointer">

                                    <td>
                                        {{(pageSize*(currentPageNumber-1)) + (index + 1)}}
                                    </td>
                                    <td>{{fieldMasterDetails.categoryName}}</td>
                                    <td style="white-space:normal;">{{fieldMasterDetails.modelName}}</td>
                                </tr>
                            </tbody>


                        </table>


                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-9 pull-right zIndex1000">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="{{pageSize}}" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>

                                    
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span><b>  {{page.totalElements}}
                                                {{page.totalElements > 1 ? 'Records' : 'Record'}} Found. </b>
                                    </span>
                                    <span *ngIf="blnDirtySearch">
                                            <a style="cursor:pointer"
                                                (click)="executeFieldMasterSearchClear()">
                                                (<span><i class="fa fa-trash-o"></i></span>
                                                    <b>Clear Search</b>
                                            </a>)
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>